import { useTranslation } from 'react-i18next';
import { BundlesGridView } from '~/components/catalog/bundles/grid';
import { PageContainer } from '~/components/page-container';
import { useHasAccess } from '~/lib/auth/use-has-access';

export function Bundles() {
	const { t } = useTranslation();
	// AuthGuard only checks login and the menu only hides the entry; the Bundles endpoints require the
	// Catalog role, so a direct URL must be gated too (the grid — and its queries — never mount when denied).
	const canManage = useHasAccess()('Catalog');
	return (
		<PageContainer>
			{canManage ? (
				<BundlesGridView />
			) : (
				<div className="rounded-lg border border-border bg-surface p-8 text-center text-sm text-foreground-muted">
					{t('catalog.bundles.noAccess')}
				</div>
			)}
		</PageContainer>
	);
}
